module.exports = __webpack_public_path__ + "img/exp_pin_selected.f08ccbc8.png";